import { c as _c } from "react/compiler-runtime";
import styles from './index.module.scss';
const STARS_NUMBER = 5;
const getScorePercentage = (score: number): number => score / 5 * 100;
interface Props {
  score: number;
}
export const Stars = t0 => {
  const $ = _c(12);
  const {
    score
  } = t0;
  let t1;
  if ($[0] !== score) {
    t1 = score.toString();
    $[0] = score;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `Valutazione: ${t1} su ${STARS_NUMBER}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path id="star" d="M10.471 5.267L8.453.964c-.118-.25-.415-.357-.665-.24-.106.05-.191.135-.24.24l-2.02 4.303-4.566.697c-.273.042-.46.297-.419.57.016.103.064.2.136.274L4 10.21l-.778 4.773c-.044.272.14.53.413.574.111.018.225-.002.323-.056L8 13.267l4.043 2.235c.242.133.546.046.68-.196.054-.098.074-.212.055-.322L12 10.21l3.32-3.403c.193-.198.19-.514-.008-.707-.075-.073-.17-.12-.274-.137l-4.567-.697z" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs>{t3}<clipPath id="star-clip-path"><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" /><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" x="16" /><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" x="32" /><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" x="48" /><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" x="64" /></clipPath></defs>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <g fill="#DFE3ED"><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" /><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" x="16" /><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" x="32" /><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" x="48" /><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" x="64" /></g>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== score) {
    t6 = getScorePercentage(score).toString();
    $[5] = score;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = `${t6}%`;
  let t8;
  if ($[7] !== t7) {
    t8 = <svg viewBox="0 0 80 16" xmlns="http://www.w3.org/2000/svg">{t4}{t5}<rect className={styles.rect} x="0" y="0" width={t7} height="100%" clipPath="url(#star-clip-path)" /></svg>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t2 || $[10] !== t8) {
    t9 = <div className={styles.stars} aria-label={t2}>{t8}</div>;
    $[9] = t2;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};